module.exports = __webpack_public_path__ + "img/123.bdf9cae8.png";